export const study_info = {
  'sorghum_bicolor': {
    '1': { label: 'Purdue EMS', type: 'EMS' },
    '2': { label: 'USDA Lubbock EMS', type: 'EMS' },
    '3': { label: 'Lozano', type: 'NAT' },
    '4': { label: 'USDA Lubbock EMS', type: 'EMS' },
    '5': { label: 'Boatwright SAP', type: 'NAT' },
    '7': { label: 'Kumar BAP', type: 'NAT' },
    '8': { label: 'Lasky landraces', type: 'NAT' },
    '9': { label: 'Sorghum Genomics Toolbox', type: 'NAT' }
  },
  'zea_maysb73': {
    '15': { label: 'MaizeGDB 2024', type: 'NAT' }
  },
  'oryza_sativa': {
    '7': { label: 'Rice 3K', type: 'NAT' },
    '20': { label: '19K-RGP', type: 'NAT' },
    '29': { label: 'Rice USDA mini core', type: 'NAT' },
    '38': { label: 'RAPDB 2024', type: 'NAT' }
  },
  'oryza_aus': { '20': { label: '19K-RGP', type: 'NAT' } },
  'oryza_sativa117425': { '20': { label: '19K-RGP', type: 'NAT' } },
  'oryza_sativair64rs2': { '20': { label: '19K-RGP', type: 'NAT' } },
  'oryza_sativamh63': { '20': { label: '19K-RGP', type: 'NAT' } }
};
